import o from "./index799.js";
import r from "./index881.js";
import i from "./index812.js";
var u = r ? function(t, e) {
  return r(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: o(e),
    writable: !0
  });
} : i;
export {
  u as default
};
